module.exports = __webpack_public_path__ + "media/images/MainPhoto-27575a9ae810d9aac0543035703d5a69.jpg";